import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import ActionEdit from 'material-ui/svg-icons/editor/mode-edit';
import ActionRemove from 'material-ui/svg-icons/action/delete';
import FontIcon from 'material-ui/FontIcon';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import StageDialog from '../../StageDialog';
import { showDialog, hideDialog, isDialogOpen } from '../../../actions/dialogs';

import styles from './styles';

import Icon from '../../Common/Icon';

class StagesTable extends Component {
  static propTypes = {
    stages: PropTypes.array,
    onChange: PropTypes.func.isRequired,

    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
  }

  handleSave = (stage) => {
    console.log('handleSave', stage);
    let found = false;
    const stages = this.props.stages.map((s) => {
      if (stage.id === s.id) {
        found = true;
        return stage;
      }

      return s;
    });

    if (!found) {
      stages.push(stage);
    }

    this.props.onChange(stages);
  };

  handleAdd = () => {
    this.handleEdit({});
  };

  handleEdit = (stage) => {
    this.props.showDialog('stage', { stage });
  };

  handleRemove = (stage) => {
    const context = {
      type: 'warning',
      title: 'Remove Stage?',
      message: 'Are you sure you wish to remove this stage?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.onChange(this.props.stages.filter((r) => r.id !== stage.id));
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  renderStage = (stage) => {
    console.log('stage.qualityControl', stage.qualityControl);
    return (<TableRow key={stage.id} selectable={false}>
      <TableRowColumn style={styles.iconCol}>
        { stage.icon ? <Icon name={stage.icon} style={styles.stageIcon}/> : null }
      </TableRowColumn>
      <TableRowColumn style={styles.nameCol}>{stage.name}</TableRowColumn>
      <TableRowColumn style={styles.typeCol}>{stage.type}</TableRowColumn>
      <TableRowColumn
        style={styles.qualityControlCol}>{stage.qualityControl && stage.qualityControl.questions && stage.qualityControl.questions.length ? 'Yes' : 'No'}</TableRowColumn>
      <TableRowColumn style={styles.actionCol}>
        <IconButton tooltip="Edit" tooltipPosition="bottom-center" onClick={() => this.handleEdit(stage)}>
          <ActionEdit />
        </IconButton>
        <IconButton tooltip="Remove" tooltipPosition="bottom-center" onClick={() => this.handleRemove(stage)}>
          <ActionRemove />
        </IconButton>
      </TableRowColumn>
    </TableRow>);
  };

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <FontIcon className="material-icons" style={styles.noData}>transform</FontIcon>
      <div>No stages created yet...</div>
      { this.renderAdd() }
    </div>);
  }

  renderAdd() {
    return (<div style={styles.addItemContainer}>
      <FloatingActionButton style={styles.addItem} secondary onClick={this.handleAdd}>
        <ContentAdd />
      </FloatingActionButton>


      { isDialogOpen(this.props.dialogs, 'stage') ? <StageDialog
        stage={this.props.dialogs.stage.context.stage}
        onCancel={() => this.props.hideDialog('stage')}
        onSave={this.handleSave}/> : null }
    </div>);
  }

  render() {
    if (!this.props.stages || this.props.stages.length === 0) {
      return this.renderNoData();
    }

    console.log('stagess', this.props.stages);

    return (<div><Table selectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={styles.iconCol}></TableHeaderColumn>
          <TableHeaderColumn style={styles.nameCol}>Name</TableHeaderColumn>
          <TableHeaderColumn style={styles.typeCol}>Type</TableHeaderColumn>
          <TableHeaderColumn style={styles.qualityControlCol}>Quality Control</TableHeaderColumn>
          <TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {this.props.stages.map(this.renderStage)}
      </TableBody>
    </Table>

      { this.renderAdd() }
    </div>);
  }
}

function mapStateToProps(state) {
  return {
    // jobProfile: state.get('jobprofiles').get('jobProfile').toJS(),
    // initialValues: state.get('jobprofiles').get('jobProfile').toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StagesTable);



// WEBPACK FOOTER //
// ./src/components/JobProfile/StagesTable/index.js